import React from "react";

export const Divider = ({ full = false, className = "" }) => (
  <span
    aria-hidden="true"
    className={`${full ? "brand-divider-full" : "brand-divider"} ${className}`}
  />
);

export default Divider;
